import { render, staticRenderFns } from "./PinDraft.vue?vue&type=template&id=15a3903c&scoped=true&"
import script from "./PinDraft.vue?vue&type=script&lang=js&"
export * from "./PinDraft.vue?vue&type=script&lang=js&"
import style0 from "./PinDraft.vue?vue&type=style&index=0&id=15a3903c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3903c",
  null
  
)

export default component.exports